import { forwardRef } from 'react';
import CloseIcon from 'assets/icons/close-icon.svg?react';
import styles from './style.module.scss';

export type UICenteredModalProps = {
  visible: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  showGradientBorder?: boolean;
  showGlow?: boolean;
  maxWidth?: string | number;
  width?: string | number;
  animationDuration?: number;
  backdropBlur?: number;
  showCloseButton?: boolean;
  disableBackdropClick?: boolean;
};

export const UICenteredModal = forwardRef<HTMLDivElement, UICenteredModalProps>(
  (
    {
      visible,
      onClose,
      children,
      className,
      contentClassName,
      showGradientBorder = false,
      showGlow = false,
      maxWidth = '380px',
      width = '90%',
      animationDuration = 0.4,
      backdropBlur = 20,
      showCloseButton = true,
      disableBackdropClick = false,
    },
    ref,
  ) => {
    if (!visible) return null;

    const handleContentClick = (e: React.MouseEvent) => {
      e.stopPropagation();
    };

    const contentStyle = {
      maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
      width: typeof width === 'number' ? `${width}px` : width,
    };

    // For now, let's always show gradient border and glow since TaskModal uses them
    return (
      <div className={styles.modalOverlay} onClick={onClose}>
        <div className={styles.modalWrapper} style={contentStyle}>
          <div
            ref={ref}
            className={`${styles.modalContent} ${contentClassName || ''}`}
            onClick={handleContentClick}
          >
            {showCloseButton && (
              <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
                <CloseIcon />
              </button>
            )}
            {children}
          </div>
        </div>
      </div>
    );
  },
);

UICenteredModal.displayName = 'UICenteredModal';
